import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryFileUploadCompleteService = (
  data: any,
  signal: AbortSignal,
) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.CUSTOMER_DELIVERY.UPLOAD.COMPLETE
    : ENDPOINTS.ADMIN.CUSTOMER_DELIVERY.UPLOAD.COMPLETE;

  return axiosInstance
    .post(URL, data, { signal })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
